import React from "react";
import { useTranslation } from "react-i18next";

// Icons
import { RiRobot3Line } from "react-icons/ri";

// Components
import Typography from "../../Typography";

// Styles
import styles from "./style.module.scss";

const Waiting: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.waitingContainer}>
      <RiRobot3Line size={24} className={styles.waitingContainer_icon} />

      <Typography variant="p" className={styles.waitingContainer_text}>
        {t('chat.waiting')}
      </Typography>

      <div className={styles.waitingContainer_dots}>
        <span className={styles.waitingContainer_dot} />
        <span className={styles.waitingContainer_dot} />
        <span className={styles.waitingContainer_dot} />
      </div>
    </div>
  )
}

export default Waiting;
